import React, { useEffect } from "react";
import ApexCharts from "apexcharts";
import { useFilter } from "../../../../FilterContext";
import jsonData from "../../../../current-survey-numeric.json";
import "./engagement-summary.css"; // Import the prefixed CSS file

const JobSatisfactionChart = () => {
  const { filterCriteria } = useFilter();

  const calculateAverageScores = (data, categories) => {
    const scores = Object.keys(categories).reduce((acc, key) => {
      // Flatten all valid scores for each category
      const categoryScores = categories[key].flatMap((question) =>
        data
          .map((item) => item[question])
          .filter(
            (score) =>
              score !== undefined && score !== null && score >= 1 && score <= 5
          )
      );

      // Calculate direct average for the category
      acc[key] = categoryScores.length
        ? categoryScores.reduce((a, b) => a + b, 0) / categoryScores.length
        : 0;

      acc[key] = parseFloat(acc[key].toFixed(1)); // Round to one decimal place
      return acc;
    }, {});

    return scores;
  };

  useEffect(() => {
    const categories = {
      "Job Satisfaction: Recognition": ["MQ0053", "MQ0171", "MQ0103"],
      "Job Satisfaction: Autonomy": ["MQ0071", "MQ0202", "MQ0027"],
      "Job Satisfaction: Meaningfulness": ["MQ0023", "MQ0024", "MQ0026"],
      "Job Satisfaction: Growth": ["MQ0064", "MQ0062", "MQ0043"],
      "Job Satisfaction: Teamwork": ["MQ0340", "MQ0341", "MQ0094"],
    };

    const filteredData = jsonData.filter((item) => {
      return Object.keys(filterCriteria).every((key) => {
        const criteria = filterCriteria[key];
        if (Array.isArray(criteria)) {
          return criteria.length === 0 || criteria.includes(item[key]);
        }
        return criteria === "" || item[key] === criteria;
      });
    });

    const scores = calculateAverageScores(filteredData, categories);

    const options = {
      chart: {
        type: "bar",
        height: "100%", // Fill height
        width: "100%", // Fill width
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      legend: {
        show: false,
      },
      title: {
        text: "Average Scores by Job Satisfaction",
        align: "Center",
        style: {
          fontSize: "20px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 1,
          horizontal: true,
          dataLabels: {
            position: "top",
          },
          barHeight: "90%",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val.toFixed(1),
        offsetX: 55,
        style: {
          colors: ["#000"],
        },
      },
      series: [
        {
          name: "Avg Score",
          data: [
            scores["Job Satisfaction: Autonomy"],
            scores["Job Satisfaction: Growth"],
            scores["Job Satisfaction: Meaningfulness"],
            scores["Job Satisfaction: Recognition"],
            scores["Job Satisfaction: Teamwork"],
          ],
        },
      ],
      colors: ["#008000"],
      xaxis: {
        max: 5.0,
        categories: [
          "Autonomy",
          "Growth",
          "Meaningfulness",
          "Recognition",
          "Teamwork",
        ],
      },
      yaxis: {
        labels: {
          show: true,
          minWidth: 120,
        },
      },
    };

    const chart = new ApexCharts(document.querySelector("#js-bar"), options);
    chart.render();

    return () => {
      chart.destroy();
    };
  }, [filterCriteria]);

  return (
    <div className="engagement-summary-chart-container">
      <div id="js-bar"></div>
    </div>
  );
};

export default JobSatisfactionChart;
